export default {"src":"https://images-cdn.curipod.com/d-bdb94e66/_next/static/media/votingLong.34fa6347.svg","height":770,"width":2869};